module.exports = " <ol class=breadcrumb> <li v-for=\"item in list\"><span class=active v-if=isLast($index)>{{item.label}}</span> <a v-link=\"{ name: item.link }\" v-else>{{item.label}}</a> </li> </ol> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-breadcrumb/src/Breadcrumb.vue
// module id = 913
// module chunks = 2